<span
  (overlayClosed)="close(true)"
  [classList]="[name]"
  [content]="mainTemplate"
  uiOverlay
  >
  <ng-content></ng-content>
</span>

<ng-template #mainTemplate>
  <mat-card class="mat-elevation-z">
    @if (showHeader) {
      <div class="header">
        <h5 class="title">{{ title }}</h5>
        <button (click)="close(true)" aria-label="close" class="overlay-close-icon" mat-icon-button>
          <ui-icon faName="xmark" faStyle="light"></ui-icon>
        </button>
      </div>
    }
    <mat-card-content>
      <div [class]="contentClass" class="content">
        <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
      </div>
    </mat-card-content>
  </mat-card>
</ng-template>
